var $ = require("jquery");

var AgencyReview = Backbone.View.extend({
  initialize: function() {
    this.modal = this.$("[data-agency-review-modal]");

    var Dialog = this.modal.component();

    $(document).on("submit", "[data-agency-review-form]", function(event) {
      event.preventDefault();

      var formData = $(this).serializeJSON();

      $.ajax({
        type: "post",
        dataType: "html",
        cache: false,
        url: $(this).attr("action"),
        data: $(this).serialize(),

        beforeSend: function() {
          Backbone.Events.trigger("loadingSplashOn");
        },

        success: function(response) {
          response = $(response);

          Dialog.currentModal.find("[data-dialog-content]").html(response);

          $(response).loadComponents();
          $(response).loadModules();

          Dialog.reflow();

          Backbone.Events.trigger("loadingSplashOff");

          return true;
        },

        error: function() {
          Backbone.Events.trigger("loadingSplashOff");
          return false;
        }
      });
    });
  }
});

module.exports = AgencyReview;
